// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import React from "react";
import "./App.css";
import { TeamsUserCredential } from "@microsoft/teamsfx";
import { Button } from "@fluentui/react-components";
import { Providers, ProviderState } from "@microsoft/mgt-element";
import { TeamsFxProvider } from "@microsoft/mgt-teamsfx-provider";
import { CacheService } from "@microsoft/mgt";

import { apiScopes } from "./lib/apiScopes";
import config from "./lib/config";
import { getCurrentLanguage, translate, translateMultiple } from "./lib/translator";








class Tab extends React.Component {

  constructor(props) {

    super(props);
    const cacheId = Providers.getCacheId();

    CacheService.clearCacheById(cacheId);

    this.state = {
      showLoginPage: undefined,
      showLoadingCircle: undefined,
    };

  }


  async componentDidMount() {

    var isIOS = (() => {
        if (typeof window === `undefined` || typeof navigator === `undefined`) return false;

        return /iPhone|iPad|iPod/i.test(navigator.userAgent || navigator.vendor || (window.opera && window.opera.toString() === `[object Opera]`));
    })();

    if(isIOS) {
        Object.keys(localStorage).filter((storageKey) => sessionStorage.getItem(storageKey) === null).forEach(key => {
          sessionStorage.setItem(key, localStorage.getItem(key));
        }
      );
    }

    /*Initialize TeamsFX provider*/
    this.credential = new TeamsUserCredential(
      {
        initiateLoginEndpoint: config.initiateLoginEndpoint,
        clientId: config.clientId,
      }
    );

    const provider = new TeamsFxProvider(this.credential, apiScopes);
    Providers.globalProvider = provider;

    /*Check if consent is needed*/
    let consentNeeded = false;
    
    try {
      await this.credential.getToken(apiScopes);

    } catch (error) {
      consentNeeded = true;

    }

    this.setState(
      {
        showLoadingCircle: !consentNeeded,
      }
    );

    this.setState(
      {
        showLoginPage: consentNeeded,
      }
    );

    Providers.globalProvider.setState(
      consentNeeded ? ProviderState.SignedOut : ProviderState.SignedIn
    );

    return consentNeeded;

  }


  async loginBtnClick() {

    try {

      await this.credential.login(apiScopes);

      Providers.globalProvider.setState(ProviderState.SignedIn);

      this.setState(
        {
          showLoadingCircle: true,
        }
      );

      setTimeout(
        () => {
          
          this.setState(
            {
              showLoginPage: false,
            }
          );

        }, 5000
      );

    } catch (err) {

      if (err.message?.includes("CancelledByUser")) {

        const helpLink = "https://aka.ms/teamsfx-auth-code-flow";
        err.message +=
          '\nIf you see "AADSTS50011: The reply URL specified in the request does not match the reply URLs configured for the application" ' +
          "in the popup window, you may be using unmatched version for TeamsFx SDK (version >= 0.5.0) and Teams Toolkit (version < 3.3.0) or " +
          `cli (version < 0.11.0). Please refer to the help link for how to fix the issue: ${helpLink}`;
      }

      alert("Login failed: " + err);

      return;

    }

  }


  render() {


    if(this.state.showLoginPage === false) {

        const startRoomPlanner = async () => {


          const fetchTokenProperties = async () => {

            const accessTokenProperties = await this.credential.getToken(apiScopes);

            const accessToken = accessTokenProperties.token;
            const accessTokenExpirationTimestamp = accessTokenProperties.expiresOnTimestamp
            

            const refreshTokenKey = this.credential.msalInstance.getTokenCache().storage.getTokenKeys().refreshToken[0];                  //or this way (access token could be also retrieved)
            const refreshToken = this.credential.msalInstance.browserStorage.getRefreshTokenCredential(refreshTokenKey).secret;           //this.credential.msalInstance.tokenCache.storage.getRefreshTokenCredential(refreshTokenKey).secret

            const clientId = this.credential.msalInstance.browserStorage.clientId;
            const tenantId = "53a7db7f-2d41-4a9a-82fe-872f1bf005f6";
            const apiTokenScopes = apiScopes;

            return { accessToken, accessTokenExpirationTimestamp, refreshToken, clientId, tenantId, apiTokenScopes };

          };


          const generateRoomPlannerAPITokenProperties = async () => {

            const { accessToken, accessTokenExpirationTimestamp, refreshToken, clientId, tenantId, apiTokenScopes } = await fetchTokenProperties();

            const RoomPlannerAPITokenProperties = {

              "accessToken": accessToken, 
              "accessTokenExpirationTimestamp": accessTokenExpirationTimestamp, 
              "refreshToken": refreshToken, 
              "clientId": clientId,
              "tenantId": tenantId,
              "apiTokenScopes": apiTokenScopes

            };

            return RoomPlannerAPITokenProperties;

          };


          const storeRoomPlannerAPITokenProperties = (RoomPlannerAPITokenProperties) => {

            const RoomPlannerAPITokenPropertiesJSON = JSON.stringify(RoomPlannerAPITokenProperties);

            sessionStorage.setItem('RoomPlannerAPITokenProperties', RoomPlannerAPITokenPropertiesJSON);

          };


          const openRoomPlannerURL = () => {

            window.location.href = "/RoomPlanner/index.html";

          };


          
          const RoomPlannerAPITokenProperties = await generateRoomPlannerAPITokenProperties();

          storeRoomPlannerAPITokenProperties(RoomPlannerAPITokenProperties);

          openRoomPlannerURL();
          

        };

        startRoomPlanner();

    }

    const generateTranslations = () => {

      const translationKeys = [
        "TabWelcomeTitle", 
        "TabWelcomeDescriptionText", 
        "TabLoginButtonText"
      ];

      const _translatedTexts = translateMultiple(translationKeys);

      return _translatedTexts;

    };

    const _translations = generateTranslations();


    return (

      <div>

        {this.state.showLoadingCircle === true && (

            <div style={
              {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }
            }>
              <img src='loading.gif' alt="loading..." />
            </div>
            
          )
        }
        {this.state.showLoginPage === true && (
          
            <div className="auth">

              <h3>{_translations["TabWelcomeTitle"]}</h3>

              <p>
                {_translations["TabWelcomeDescriptionText"]}
              </p>

              <Button appearance="primary" onClick={() => this.loginBtnClick()}>
                {_translations["TabLoginButtonText"]}
              </Button>

            </div>
          )
        }

      </div>
      
    );


  }
  
}
export default Tab;